export default class Globals
{
	static isSafari: boolean;
	
}
